import { render, staticRenderFns } from "./formListaEmbarquePallet.vue?vue&type=template&id=197a8af6&"
import script from "./formListaEmbarquePallet.vue?vue&type=script&lang=js&"
export * from "./formListaEmbarquePallet.vue?vue&type=script&lang=js&"
import style0 from "./formListaEmbarquePallet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports